import { render, staticRenderFns } from "./base-layout.vue?vue&type=template&id=d9531458"
import script from "./base-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./base-layout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-layout.vue?vue&type=style&index=0&id=d9531458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports